import { navigationActions } from "../reducer";

export const resetClientEventHistory = () => navigationActions.resetClientEventHistory();
